import React from "react";

export const ModalServiceWarning = () => {

	return (
		<div className="modal fade px-0" id="warningService" aria-labelledby="warningServiceLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert alert-warning rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="sr-only visually-hidden">Attention</h5>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-warning text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="warningValiderLabel">
									Attention
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						<div className="o-80">
							Veuillez compléter 100 % des services sélectionnés ou mettre en favoris (en cliquant sur l'icône étoile <i className="eva eva-star-outline text-warning"></i>) pour accéder à l'espace courriers, sinon les supprimer afin de les ajouter plus tard
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-warning" data-dismiss="modal">
							J'ai compris
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
